/**
 * Domains tab — placeholder matching the source `admin_panel.html` stub.
 * The source template's `loadDomains()` renders "Domain management coming
 * soon" and `openAddDomainModal()` shows a toast. We match that here.
 */

function showToast(msg: string) {
  const el = document.createElement("div")
  el.textContent = msg
  el.className =
    "fixed top-4 right-4 z-[9999] rounded-lg px-4 py-3 text-sm font-medium shadow-lg bg-blue-900/90 text-blue-200 border border-blue-700"
  document.body.appendChild(el)
  setTimeout(() => el.remove(), 5000)
}

export default function DomainsTab() {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col gap-4 overflow-hidden">
      <div className="flex shrink-0 justify-end">
        <button
          className="rounded-md border border-[#8fa0ef]/35 bg-[#7488e8] px-4 py-2 font-semibold text-white shadow-sm transition-colors hover:bg-[#687bda]"
          onClick={() => showToast("Domain management feature coming soon")}
        >
          + Add Domain
        </button>
      </div>
      <div className="py-8 text-center">
        <p className="text-lg font-medium text-white">
          Domain management coming soon
        </p>
        <p className="mt-2 text-sm text-white">
          This feature is under development and will be available in a future
          update.
        </p>
      </div>
    </div>
  )
}
